import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

require('./bringoz-tag.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-tag',
  templateUrl: './bringoz-tag.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozTagComponent implements OnInit, OnChanges {

  @Input() name: string;
  @Input() color: string;
  @Input() backgroundColor: string;
  @Input() isHideTooltip: boolean = false;
  @Input() description: string;

  public options: any;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.options = this.splitService.getIsSite() ? this.splitService.getSiteSkills() : [];
    this.initTag();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.name && !changes.name.isFirstChange() || changes.color && !changes.color.isFirstChange()) {
      this.initTag();
    }
  }

  private initTag() {
    if (!this.backgroundColor) {
      const tag = this.options.find((o) => {
        return o.name === this.name
      })

      if (!!tag) {
        this.backgroundColor = tag.color;
      }
    }
  }


}
